'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Collapse = require('./Collapse');

var _Collapse2 = _interopRequireDefault(_Collapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Collapse2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/collapse/index.js
// module id = A/Ib
// module chunks = 0